import { atom } from "jotai";

export const DomainsStepState = {
  isLoadingFirmographicsAtom: atom<boolean>(false),
  numberOfSelectedDomains: atom<number>(0),
};
